// FILECONTENT_START src/common/components/List/useFilter.ts
import { identity, omit, pickBy } from "lodash";
import { useEffect, useState } from "react";
import { Options } from "./../../modules/helpers";
import useDeepEffect from "./../Form/useDeepEffect";

export interface UseFilterReturnType<TItem, TOptions = Options> {
  showFilter: boolean;
  setShowFilter: Function;
  options: TOptions;
  item: TItem;
  filterCount: number;
  onChange: (newItem: TItem) => void;
}

export interface UseFilterProps<T = any, O extends Options = Options> {
  filter: T;
  loadOptions?: (config: any) => Promise<O>;
  attributesNotCount?: string[];
  optionParams?: (filter: any) => any;
}

export default function useFilter<T = any, O extends Options = Options>({
  filter,
  loadOptions: _loadOptions,
  attributesNotCount,
  optionParams,
}: UseFilterProps<T, O>): UseFilterReturnType<T, O> {
  const [item, setItem] = useState<T>(filter);
  const [showFilter, setShowFilter] = useState(false);

  useDeepEffect(() => {
    setItem(filter);
  }, [filter]);

  const __filter = pickBy(filter as any, identity);
  const filterCount = Object.keys(
    attributesNotCount ? omit(__filter, attributesNotCount) : __filter
  ).length;

  const [options, setOptions] = useState<O>({} as O);

  async function loadOptions() {
    if (_loadOptions) {
      console.log("LOAAAD", filter, optionParams);
      const params: any = await _loadOptions({
        params: optionParams ? optionParams(filter) : undefined,
      });
      setOptions(params?.options);
    }
  }

  useEffect(() => {
    if (showFilter) {
      loadOptions();
    }
  }, [showFilter]);

  return {
    options,
    showFilter,
    setShowFilter,
    item,
    filterCount,
    onChange: setItem,
  };
}

// FILECONTENT_END src/common/components/List/useFilter.ts
